import { Component, Input, OnInit, inject } from "@angular/core";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { SkillProfileStore } from "@app/services/store/skill-profile-store";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseSingleEntityPageComponent } from "@app/view/shared/base-pages/base-single-entity-page/base-single-entity-page.component";
import {
  ChildEntityDeletionBehaviour,
  ChildEntityModel
} from "@app/view/shared/child-entity-manager/child-entity-model";
import { SkillRule } from "@app/models/rest/skill-rule";
import { SkillRuleStore } from "@app/services/store/skill-rule-store";
import { SkillRuleAddComponent } from "@app/view/setup/assignment/skill-rule-add/skill-rule-add.component";
import { Skill } from "@app/models/rest/skill";
import { ChildEntitySkillRuleDisplayComponent } from "@app/view/shared/child-entity-skill-rule-display/child-entity-skill-rule-display.component";
import { ChildEntityManagerComponent } from "../../../shared/child-entity-manager/child-entity-manager.component";

@Component({
  selector: "app-scheduler-skill-profile-detail",
  templateUrl: "./skill-profile-detail.component.html",
  styleUrls: ["./skill-profile-detail.component.scss"],
  imports: [ChildEntityManagerComponent]
})
export class SkillProfileDetailComponent
  extends BaseSingleEntityPageComponent<SkillProfile>
  implements OnInit
{
  skillProfileStore = inject(SkillProfileStore);
  skillRuleStore = inject(SkillRuleStore);
  router = inject(Router);

  @Input()
  public skillProfileId: number;

  protected skillProfile: SkillProfile;

  public childEntities: {
    skill: ChildEntityModel<SkillRule, SkillProfile>;
  } = { skill: null };

  constructor() {
    super();

    this.childEntities.skill = {
      type: SkillRule,
      relation: "skill",
      display: "description",
      title: "scheduler.setup.skillRules.title",
      addComponent: SkillRuleAddComponent,
      displayComponent: ChildEntitySkillRuleDisplayComponent,
      searchKey: "skillProfile",
      readonly: false,
      store: this.skillRuleStore,
      searchQuery: "findBySkillProfileIs",
      deletionBehaviour: ChildEntityDeletionBehaviour.LINK_TABLE,
      parentStore: this.skillProfileStore,
      parentType: Skill,
      parentRelation: "skills"
    };
  }

  ngOnInit() {
    this.skillProfileStore
      .loadSingleProjection(SkillProfile, this.skillProfileId, "detail")
      .then((value) => {
        this.skillProfile = value;
        super.loadDataSource(this.skillProfileStore);
      });
  }

  retryLoad() {
    super.retry(this.skillProfileStore);
  }

  openNewSkillDialog() {
    /*  const dialogRef = this.dialog.open(SkillProfileEditorComponent, {
      width: '350px',
      data: { mode: 'NEW' }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
    });*/
  }

  updateSkillProfile() {
    this.skillProfileStore.update(this.skillProfile).subscribe(
      () => {
        this.ngOnInit();
        this.router.navigate(["/setup/skillProfiles"]);
      },
      (error) => {
        console.log("error");
        console.log(error);
        alert(error.error.message);
      }
    );
  }
}
